import classes from './TrackerBadge.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  counter: number
  icon?: ReactNode
  variant: 'filter' | 'tag' | 'error' | 'grey' | 'warning'
  size?: 'small' | 'large'
  ariaLabel?: string
}

const TrackerBadge = ({
  counter,
  icon,
  variant,
  size = 'large',
  ariaLabel
}: Props) => {
  const leadingSymbol = variant === 'tag'
    ? '+'
    : ''

  const styleClasses = [
    classes.TrackerBadge,
    classes[variant],
    classes[size]
  ].filter(styleClass => styleClass).join(' ')

  return (
    <span
      aria-label={ariaLabel}
      className={styleClasses}
    >
      <span>
        {leadingSymbol}
        {
          !icon &&
          counter
        }
        {icon}
      </span>
    </span>
  )
}

export default TrackerBadge
